import api from "@/services/api";
import {
  AssociateNetworkFilters,
  AssociateNetworkResponse,
} from "@/types/franchise-associate/AssociateNetwork";

class GetAssociateNetwork {
  execute = async (filters: Partial<AssociateNetworkFilters> = {}) => {
    const params: Record<string, string | number> = {};
    if (filters.premiumStatus && filters.premiumStatus !== "ALL") {
      params.premiumStatus = filters.premiumStatus;
    }
    if (filters.level) {
      params.level = filters.level;
    }
    if (filters.periodStart) {
      params.periodStart = filters.periodStart;
    }
    if (filters.periodEnd) {
      params.periodEnd = filters.periodEnd;
    }

    const response = await api().get("/franchise-associates/network", {
      params,
    });
    return response.data as AssociateNetworkResponse;
  };
}

export { GetAssociateNetwork };
